import { Helmet } from "react-helmet-async";

/**
 * SEO
 * ───
 * Injects <title>, meta description, and Open-Graph + Twitter card tags with
 * a route-specific 1200×630 image rendered by `/api/og/page/:slug`.
 *
 * Usage:  <SEO slug="press" title="Press · Instantxfer CashApp" description="…" />
 */
export default function SEO({ slug = "home", title, description, path, image: imageOverride }) {
  const backend = process.env.REACT_APP_BACKEND_URL || "";
  const origin =
    typeof window !== "undefined" ? window.location.origin : "https://www.instantxfer.com";
  const url = `${origin}${path || (typeof window !== "undefined" ? window.location.pathname : "/")}`;
  const image = imageOverride || `${backend}/api/og/page/${slug}`;
  const _title = title || "Instantxfer CashApp — send money between Africa and the world in minutes";
  const _desc =
    description ||
    "The fastest, lowest-fee way to move money between Africa and the world. Mid-market rates, mobile money, cash pickup and scan-to-pay handles.";

  return (
    <Helmet prioritizeSeoTags>
      <title>{_title}</title>
      <meta name="description" content={_desc} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Instantxfer CashApp" />
      <meta property="og:title" content={_title} />
      <meta property="og:description" content={_desc} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={url} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={_title} />
      <meta name="twitter:description" content={_desc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
